import { createSearchParams } from "react-router-dom"

export const formatParams = (params: any) : string => {
  return params != null ? `?${createSearchParams(params)}` : '';
}